import staticRouterComponents from './static-router-components';

export { staticRouterComponents };

function resolveComponent(component) {
    if (typeof component === 'function') {
        return component;
    }

    //! If async-router generator has error with component string path, please check this.
    console.log(component,name,!!staticRouterComponents[component]);
    return staticRouterComponents[component]
        ? staticRouterComponents[component]
        : () => import(`@/views/${component}`);
}

function resolveRouterItem(router) {
    const meta = { ...(router.meta || {}) };
    if (Object.prototype.hasOwnProperty.call(router, 'permissions')) {
        meta.permissions = [...router.permissions];
    }
    return {
        ...router,
        meta: { ...meta },
        ...(router.component ? { component: resolveComponent(router.component) } : {})
    };
}

const accessable = (router, permissions) => {    
    if (router.permissions && router.permissions.length > 0) {
        const arr = router.permissions;
        for (const i in arr) {
            const split = arr[i].split('.');
            if (split.length == 1) {
                // 先判断是否包含这个字段
                if (permissions.hasOwnProperty.call(permissions,split[0]) && permissions[split[0]].indexOf(split[0]) !== -1) {
                    return true;
                }
            } else if (split.length == 2) {
                if (permissions.hasOwnProperty.call(permissions,split[0]) && permissions[split[0]].indexOf(split[1]) !== -1) {
                    return true;
                }
            }
        }
        return false;
    }
    return true;
};

export function resolveRoutes(routers, permissions) {
    return routers
        .map((router) => {
            if (!accessable(router, permissions)) return null;
            const item = resolveRouterItem(router);
            return {
                ...item,
                ...(item.children && item.children.length
                    ? { children: resolveRoutes(item.children, permissions) }
                    : {})
            };
        })
        .filter(Boolean);
}
